import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CompanyInfo } from '../../models/dead-letter-detail.model';
import { DisplayComparedField } from '../../services/dead-letter-compare.service';

@Component({
    selector: 'app-dead-letter-company-section',
    templateUrl: './dead-letter-company-section.component.html',
    styleUrls: ['./dead-letter-company-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeadLetterCompanySectionComponent {
  @Input() company!: CompanyInfo;
  @Input() companyCompare: Record<string, DisplayComparedField> = {};
  @Input() expanded = false;
  @Input() showChangeIndicator = false;
  @Output() expandedChange = new EventEmitter<boolean>();
}
